// src/com/plan_stat/TransPlanStateForDcView.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch'; // view tsr
import { AppStyle, AppWord } from '../../value/AppConst';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { LabelCell, ViewerCloserBox } from '../../common/TopStyle';

const DetailBox = styled(Box)({
    marginTop: '0.5rem', paddingBottom: '0.5rem',
    borderBottom: '1px solid #ccc',
    //borderRadius: '0.5rem',
    backgroundColor: '#fff',
});

const DetailHeader = styled(Box)({
    backgroundColor: '#eee', color: AppStyle.PrimaryRGB, // padding: '0.5rem',
    border: '1px solid #ddd',
    borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
});

const HeaderColumn = styled(Box)({
    textAlign: 'center', padding: '0.5rem',
});

const IconBox = styled(Box)({paddingBottom: '0.2rem', fontSize: '0.9rem'});

const BigValue = styled(Box)({fontWeight: 'bold', });

/**
 * 배차현황 상세정보.
 * TransPlanStateForDcLine 클릭했을 때 그 컴포넌트 대신에 출력됨.
 * 예전 버전에서는 팝업이었으나 지금은 inline으로 출력됨.
 * @param {*} param0 
 */
export default function TransPlanStateForDcView({
    item, // data from GET_TRANS_PLAN_TSR (src/com/tsr/TransPlanTsrGql.js)
    onClickOpenTsr,
    onClose,
}) {

    return(
        <DetailBox>
            <DetailHeader>
                <HeaderColumn>
                    <IconBox><HomeWorkIcon style={{color:'red'}} /></IconBox>
                    <BigValue>{item.dcName}</BigValue>
                </HeaderColumn>
                <DoubleArrowIcon />
                <HeaderColumn>
                    <IconBox><LocalShippingIcon style={{color: AppStyle.SecondaryRGB}} /></IconBox>
                    <BigValue>{item.vehPlates || '.....'}</BigValue>
                </HeaderColumn>
                <DoubleArrowIcon />
                <HeaderColumn>
                    <IconBox><StorefrontIcon style={{color:'red'}} /></IconBox>
                    <BigValue>{item.storeName}</BigValue>
                </HeaderColumn>
            </DetailHeader>
            <TableContainer component={Paper}>
                <Table size={AppWord.SMALL}>
                    <TableBody>
                        <TableRow>
                            <LabelCell>의뢰번호</LabelCell>
                            <TableCell>{item.planId}</TableCell>
                            <LabelCell>Dock No.</LabelCell>
                            <TableCell>{item.dockno}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>도착지</LabelCell>
                            <TableCell>{item.storeName}</TableCell>
                            <LabelCell>호차</LabelCell>
                            <TableCell>{item.hocha}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>배차구분</LabelCell>
                            <TableCell>{item.transType}</TableCell>
                            <LabelCell>차종</LabelCell>
                            <TableCell>{item.vehTypeName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>접안요청시간</LabelCell>
                            <TableCell>{item.shprReqTime ? item.shprReqTime.substring(0,16) : '-'}</TableCell>
                            <LabelCell rowSpan={3}>TSR</LabelCell>
                            <TableCell rowSpan={3}>
                                {
                                    item.reqStateFlag === '2' ?
                                    <Button
                                        variant={AppStyle.mui.outlined}
                                        color={AppStyle.mui.primary}
                                        size={AppWord.SMALL}
                                        startIcon={<ContentPasteSearchIcon />}
                                        onClick={() => onClickOpenTsr(item)}
                                        style={{borderRadius: '1rem'}}
                                    >
                                        발행됨
                                    </Button>
                                    :
                                    <span style={{
                                        color:'#555',
                                        border: '1px solid #555',
                                        borderRadius: '1rem', padding: '0.5rem'
                                    }}
                                    >미발행</span>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>출발요청시간</LabelCell>
                            <TableCell>{item.dptrReqTime ? item.dptrReqTime.substring(0,16) : '-'}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>도착요청시간</LabelCell>
                            <TableCell>{item.arrReqTime ? item.arrReqTime.substring(0,16) : '-'}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>비고</LabelCell>
                            <TableCell colSpan={3}>{item.note}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>차량번호</LabelCell>
                            <TableCell>{item.vehPlates || '미정'}</TableCell>
                            <LabelCell>운송사</LabelCell>
                            <TableCell>{item.comName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>기사</LabelCell>
                            <TableCell>{item.driverName || '미정'}</TableCell>
                            <LabelCell>전화</LabelCell>
                            <TableCell>
                                {
                                    item.driverMobile ?
                                    <a href={`tel:${item.driverMobile}`}>{item.driverMobile}</a>
                                    :
                                    '-'
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>도착지 사무실</LabelCell>
                            <TableCell>{item.storeStaffName}</TableCell>
                            <LabelCell>연락처</LabelCell>
                            <TableCell>
                                {
                                    item.storeOfficeTelno ?
                                    <a href={`tel:${item.storeOfficeTelno.replace(/\D/g, '')}`}>
                                        {item.storeOfficeTelno}
                                    </a>
                                    :
                                    '-'
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>도착지 보안실</LabelCell>
                            <TableCell>{item.storeSecuStaffName}</TableCell>
                            <LabelCell>연락처</LabelCell>
                            <TableCell>
                                {
                                    item.storeOfficeTelno ?
                                    <a href={`tel:${item.storeSecuTelno.replace(/\D/g, '')}`}>
                                        {item.storeSecuTelno}
                                    </a>
                                    :
                                    '-'
                                }
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <ViewerCloserBox onClick={onClose} />
        </DetailBox>
    );
}


